import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "@/App.css";

import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import SquareAIWidget from "@/components/chat/SquareAIWidget";
import WelcomePopup from "@/components/chat/WelcomePopup";
import { ChatProvider } from "@/context/ChatContext";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

const PageWrap = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -12 }}
    transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrap><Home /></PageWrap>} />
        <Route path="/about" element={<PageWrap><About /></PageWrap>} />
        <Route path="/services" element={<PageWrap><Services /></PageWrap>} />
        <Route path="/industries" element={<PageWrap><Industries /></PageWrap>} />
        <Route path="/contact" element={<PageWrap><Contact /></PageWrap>} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ChatProvider>
          <ScrollToTop />
          <Navbar />
          <SquareAIWidget />
          <WelcomePopup />
          <main>
            <AnimatedRoutes />
          </main>
          <Footer />
        </ChatProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
